import React from 'react'
import {
    StyledMessageBannerContent,
    StyledSimpleTextBanner,
} from './SimpleTextBanner.styled'

export const SimpleTextBanner: React.FC = ({ children }) => (
    <StyledSimpleTextBanner>
        <StyledMessageBannerContent>{children}</StyledMessageBannerContent>
    </StyledSimpleTextBanner>
)
SimpleTextBanner.displayName = 'SimpleTextBanner'
